export default "__VITE_ASSET__DStBGlqP__"